import { EventProperties } from '@lentau/analytics/health-metrics/shared';

export function cartItemClearAddHandler(body: []): EventProperties {
  {
    const isEmpty = { value: true, key: 'cartItemClearAddIsEmpty' };

    return [
      {
        ...(!body && isEmpty),
      },
    ];
  }
}
